// extracted by mini-css-extract-plugin
export default {"footer-view":"index_footer-view__k38wU"};